import * as tslib_1 from "tslib";
import { BehaviorSubject, ReplaySubject, timer } from 'rxjs';
import { Api } from '../api/api';
import { GisToolsApi } from '../api/gis-tools-api';
import { environment } from '../environment';
import { LogLevel } from '../types';
import { AoiService } from './aoi.service';
import * as i0 from "@angular/core";
import * as i1 from "../api/api";
import * as i2 from "../api/gis-tools-api";
import * as i3 from "./aoi.service";
var SECOND = 1000;
var OLDYEAR = 2017;
var OPTIONS = {
    atCountyBoundary: 'deny',
    atSegmentBoundary: 'continue',
    baseUrl: environment.videoLogBaseUrl,
    imagesLocation: environment.videoLogImagesLocation,
    imageExtension: '.jpg',
    serverFolder: '/thumbnails',
    roadware1: '1',
    routeLeftImageIdentifier: '10',
    routeRightImageIdentifier: '20',
    routeCenterImageIdentifier: '00',
    rampsFolder: '/ramps',
    rampCenterImageIdentifier: '3C',
    rampLeftImageIdentifier: '1L',
    rampRightImageIdentifier: '2S'
};
var VideoLogService = /** @class */ (function () {
    function VideoLogService(api, gisToolsApi, aoiService, LoggingService) {
        this.api = api;
        this.gisToolsApi = gisToolsApi;
        this.aoiService = aoiService;
        this.LoggingService = LoggingService;
        this.atSegmentBoundary = OPTIONS.atSegmentBoundary;
        this.atCountyBoundary = OPTIONS.atCountyBoundary;
        this.showHistoricVideoLog = false;
        this.crsSelection = false;
        this.findinxlist = false;
        this.imageServerFolder = OPTIONS.serverFolder;
        this.refreshSlider = new ReplaySubject();
        this.refreshInfo = new ReplaySubject();
        this.refreshViewer = new ReplaySubject();
        this.segmentEnd = new ReplaySubject(1);
        this.countyEnd = new ReplaySubject(1);
        this.routeEnd = new ReplaySubject(1);
        this.newOffset = new ReplaySubject(1);
        this.newPlayerState = new BehaviorSubject('stop');
        this.panelsSwapped = new ReplaySubject();
        this.openThreeImageView = new ReplaySubject();
        this.imagedToggled = new ReplaySubject();
        this.imageToggleButtonsReset = new ReplaySubject();
        this.fromClick = false;
        this.segHighlightEnabled = false;
        this.keyboardEnabled = false;
        this.playerSetting = { minSpeed: 0.1, maxSpeed: 2, step: 0.1, defaultSpeed: 0.5 };
        this.playerState = 'stop';
        this._playerSpeed = Math.min(Math.max(this.playerSetting.defaultSpeed, this.playerSetting.minSpeed), this.playerSetting.maxSpeed);
        // Min: 0 (zoomed out), Max: 23 (zoomed in)
        this._followZoomLevel = 18;
        this._zoomOnPositionChange = 'zoom';
    }
    Object.defineProperty(VideoLogService.prototype, "currentYear", {
        get: function () {
            return this._currentYear;
        },
        set: function (year) {
            var _this = this;
            if (this.videoLog && this.image && this.currentYear !== year) {
                this._currentYear = year;
                if (this.yearRange && this.yearRange.years.includes(year)) {
                    this.currentYearIndex = this.yearRange.years.indexOf(year);
                }
                else if (this.yearRange && !this.yearRange.years.includes(year)) {
                    this.currentYearIndex = this.yearRange.yearIndexMax;
                }
                else {
                    this.currentYearIndex = null;
                }
                this.goToSegmentAndSetOffset(this.videoLog.countyCode, this.videoLog.stateRouteNumber, this.videoLog.segmentNumber, this.image.offset).then(function () {
                    _this.refreshViewer.next();
                });
            }
            else {
                this._currentYear = year;
                if (this.yearRange && this.yearRange.years.includes(year)) {
                    this.currentYearIndex = this.yearRange.years.indexOf(year);
                }
                else if (this.yearRange && !this.yearRange.years.includes(year)) {
                    this.currentYearIndex = this.yearRange.yearIndexMax;
                }
                else {
                    this.currentYearIndex = null;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "playerSpeed", {
        get: function () {
            return this._playerSpeed;
        },
        set: function (value) {
            this._playerSpeed = Math.min(Math.max(value, this.playerSetting.minSpeed), this.playerSetting.maxSpeed);
            if (this.playerState === 'play') {
                this.playerTimerSub.unsubscribe();
                this.playerTimerSub = timer(0, this.playerSpeed * SECOND).subscribe(this.goToNextOffset.bind(this));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "followZoomLevel", {
        get: function () {
            return this._followZoomLevel;
        },
        set: function (value) {
            if (value > 23) {
                value = 23;
            }
            if (value < 0) {
                value = 0;
            }
            this._followZoomLevel = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "zoomOnPositionChange", {
        get: function () { return this._zoomOnPositionChange; },
        set: function (val) {
            if (typeof val === 'string') {
                val = val.toLocaleLowerCase().trim();
            }
            this._zoomOnPositionChange = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "canGoToFirstOffset", {
        get: function () {
            return this.image && this.image.sequenceNumber !== undefined && this.image.sequenceNumber > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "canGoToLastOffset", {
        get: function () {
            return this.image && this.image.sequenceNumber !== undefined && this.image.sequenceNumber < (this.images.length - 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "canGoToPreviousOffset", {
        get: function () {
            return this.canGoToFirstOffset || this.canGoToPreviousSegment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "canGoToNextOffset", {
        get: function () {
            return this.canGoToLastOffset || this.canGoToNextSegment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "canGoToPreviousSegment", {
        get: function () {
            if (this.videoLog && this.videoLog.previousSegmentNumber && this.videoLog.previousCountyCode) {
                return this.videoLog.previousCountyCode === this.videoLog.countyCode ? this.atSegmentBoundary !== 'deny' : this.atCountyBoundary !== 'deny';
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "canGoToNextSegment", {
        get: function () {
            if (this.videoLog && this.videoLog.nextSegmentNumber && this.videoLog.nextCountyCode) {
                return this.videoLog.nextCountyCode === this.videoLog.countyCode ? this.atSegmentBoundary !== 'deny' : this.atCountyBoundary !== 'deny';
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "canCrossSegments", {
        get: function () {
            return this.atSegmentBoundary !== 'deny';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "canReverseDirection", {
        get: function () {
            return this.videoLog && this.videoLog.oppositeSegmentNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoLogService.prototype, "isPromptAtBoundary", {
        get: function () {
            return this.atSegmentBoundary === 'prompt';
        },
        enumerable: true,
        configurable: true
    });
    VideoLogService.prototype.resetVideoLog = function () {
        this.videoLog = null;
        this.videoLogUrl = null;
        this.image = null;
        this.yearRange = null;
        this.currentYear = null;
        this.newOffset.next(null);
    };
    VideoLogService.prototype.toggleHistoricVideoLog = function () {
        this.showHistoricVideoLog = !this.showHistoricVideoLog;
    };
    VideoLogService.prototype.toggleSegmentHighlight = function () {
        this.segHighlightEnabled = !this.segHighlightEnabled;
        if (this.segHighlightEnabled) {
            if (this.image) {
                this.highlightSegment();
            }
        }
        else {
            //remove any existing highlighted segment
            this.aoiService.clearSearchCriterias();
            this.aoiService.showBySearchCriterias(false, false, false);
        }
    };
    VideoLogService.prototype.toggleCrsSelection = function () {
        this.crsSelection = !this.crsSelection;
    };
    VideoLogService.prototype.togglefindinxlist = function () {
        this.findinxlist = !this.findinxlist;
    };
    VideoLogService.prototype.toggleKeyboardEnabled = function (enabled) {
        this.keyboardEnabled = enabled !== null && enabled !== undefined ? enabled : !this.keyboardEnabled;
    };
    VideoLogService.prototype.goToSegmentAndSetOffset = function (county, route, segment, offset, fromClick) {
        if (fromClick === void 0) { fromClick = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.goToSegment(county, route, segment)];
                    case 1:
                        _a.sent();
                        if (!(offset === 'first')) return [3 /*break*/, 2];
                        this.changeCurrentOffset(0, fromClick);
                        return [3 /*break*/, 5];
                    case 2:
                        if (!(offset === 'last')) return [3 /*break*/, 3];
                        this.changeCurrentOffset(this.images.length - 1, fromClick);
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.goToOffset(offset, fromClick)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    VideoLogService.prototype.goToSegment = function (county, route, segment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var year, result, years;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        year = this.currentYear && this.currentYearIndex !== this.yearRange.yearIndexMax ? this.currentYear.toString() : '0';
                        return [4 /*yield*/, this.gisToolsApi.getVideoLogForSegment(county, route, segment, year)];
                    case 1:
                        result = _a.sent();
                        this.videoLog = result.length > 0 ? result[0] : null;
                        this.videoLog.segmentNumber = this.videoLog && this.videoLog.streetName.toLowerCase().includes('ramp') ? this.videoLog.segmentNumber + " " + this.videoLog.streetName : this.videoLog.segmentNumber;
                        if (this.videoLog && this.videoLog.yearRange) {
                            years = this.videoLog.yearRange.map(function (x) { return parseInt(x, 10); });
                            this.yearRange = {
                                years: years,
                                yearIndexMax: years.length - 1,
                                yearIndices: Array.from(years.keys())
                            };
                            if (!this.currentYearIndex || this.currentYearIndex > this.yearRange.yearIndexMax) {
                                this.currentYearIndex = this.yearRange.yearIndexMax;
                            }
                        }
                        if (this.videoLog && this.videoLog.images) {
                            this.images = this.videoLog.images.map(function (i, idx) { return ({
                                fileName: i.fileName,
                                imageDate: i.imageDate,
                                imageName1: i.imageName1,
                                imageName2: i.imageName2,
                                imageName3: i.imageName3,
                                latitude: i.latitude,
                                longitude: i.longitude,
                                offset: i.offset,
                                sequenceNumber: idx
                            }); });
                        }
                        if (this.currentYearIndex) {
                            this.refreshSlider.next(this.currentYearIndex);
                        }
                        if (this.segHighlightEnabled && !this.aoiService.searchCriterias) {
                            this.highlightSegment();
                        }
                        else if (this.segHighlightEnabled && this.aoiService.searchCriterias && this.aoiService.searchCriterias.length > 0
                            && !(parseInt(this.videoLog.segmentNumber, 10) >= parseInt(this.aoiService.searchCriterias[0].segBgn, 10)
                                && parseInt(this.videoLog.segmentNumber, 10) <= parseInt(this.aoiService.searchCriterias[0].segEnd, 10))) {
                            this.highlightSegment();
                        }
                        this.refreshInfo.next();
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoLogService.prototype.goToOffset = function (offset, fromClick) {
        if (offset === void 0) { offset = '0'; }
        if (fromClick === void 0) { fromClick = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var targetOffset_1, offsetIndexes, exact, arrayIndex, i, image;
            return tslib_1.__generator(this, function (_a) {
                if (this.images && this.images.length > 0) {
                    targetOffset_1 = parseInt(offset, 10);
                    offsetIndexes = this.images.map(function (image, i) { return ({ originalIndex: i, offset: parseInt(image.offset, 10) }); });
                    offsetIndexes.sort(function (a, b) {
                        if (a.offset > b.offset) {
                            return 1;
                        }
                        else if (a.offset < b.offset) {
                            return -1;
                        }
                        return 0;
                    });
                    exact = offsetIndexes.find(function (i) { return i.offset === targetOffset_1; });
                    arrayIndex = offsetIndexes[0].originalIndex;
                    // TODO: Get the image based on if the offset is within the average difference of offsets between image (so get the closest image)
                    if (!exact) {
                        for (i = 0; i < this.images.length; i++) {
                            image = this.images[i];
                            if (parseInt(image.offset, 10) === targetOffset_1) {
                                arrayIndex = i;
                                break;
                            }
                            else if (this.videoLog && this.videoLog.sideIndicator !== null &&
                                ((this.videoLog.sideIndicator === '1' && parseInt(image.offset, 10) > targetOffset_1) ||
                                    (this.videoLog.sideIndicator !== '1' && parseInt(image.offset, 10) < targetOffset_1))) {
                                arrayIndex = (i > 0) ? i - 1 : 0;
                                break;
                            }
                        }
                    }
                    else {
                        arrayIndex = exact.originalIndex;
                    }
                    this.changeCurrentOffset(arrayIndex, fromClick);
                }
                return [2 /*return*/];
            });
        });
    };
    VideoLogService.prototype.togglePromptAtBoundary = function () {
        if (this.isPromptAtBoundary) {
            this.atCountyBoundary = 'continue';
            this.atSegmentBoundary = 'continue';
        }
        else {
            this.atCountyBoundary = 'prompt';
            this.atSegmentBoundary = 'prompt';
        }
    };
    VideoLogService.prototype.goToFirstOffset = function () {
        if (this.canGoToFirstOffset) {
            this.changeCurrentOffset(0);
        }
    };
    VideoLogService.prototype.goToLastOffset = function () {
        if (this.canGoToLastOffset) {
            this.changeCurrentOffset(this.images.length - 1);
        }
    };
    VideoLogService.prototype.goToPreviousOffset = function () {
        if (this.image && this.image.sequenceNumber >= 0) {
            if (this.image && this.image.sequenceNumber > 0) {
                this.changeCurrentOffset(this.image.sequenceNumber - 1);
            }
            else if (this.isPromptAtBoundary) {
                if (this.playerState === 'play') {
                    this.changePlayerState('pause');
                }
                this.segmentEnd.next('first');
            }
            else {
                this.goToPreviousSegment();
            }
        }
    };
    VideoLogService.prototype.goToNextOffset = function () {
        if (this.images && this.images.length > 0) {
            if (this.image && this.image.sequenceNumber < this.images.length - 1) {
                this.changeCurrentOffset(this.image.sequenceNumber + 1);
            }
            else if (this.isPromptAtBoundary) {
                this.changePlayerState('pause');
                this.segmentEnd.next('last');
            }
            else {
                this.goToNextSegment();
            }
        }
    };
    VideoLogService.prototype.goToPreviousSegment = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canGoToPreviousSegment) return [3 /*break*/, 5];
                        if (!(this.videoLog.previousCountyCode !== this.videoLog.countyCode && this.atCountyBoundary === 'prompt')) return [3 /*break*/, 1];
                        this.changePlayerState('pause');
                        this.countyEnd.next('first');
                        return [3 /*break*/, 4];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.goToSegmentAndSetOffset(this.videoLog.previousCountyCode, this.videoLog.stateRouteNumber, this.videoLog.previousSegmentNumber, 'last')];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.LoggingService.Log(error_1, LogLevel.Error);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.changePlayerState('stop');
                        this.routeEnd.next('first');
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    VideoLogService.prototype.goToNextSegment = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canGoToNextSegment) return [3 /*break*/, 5];
                        if (!(this.videoLog.nextCountyCode !== this.videoLog.countyCode && this.atCountyBoundary === 'prompt')) return [3 /*break*/, 1];
                        this.changePlayerState('pause');
                        this.countyEnd.next('last');
                        return [3 /*break*/, 4];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.goToSegmentAndSetOffset(this.videoLog.nextCountyCode, this.videoLog.stateRouteNumber, this.videoLog.nextSegmentNumber, 'first')];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.LoggingService.Log(error_2, LogLevel.Error);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.changePlayerState('stop');
                        this.routeEnd.next('last');
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    VideoLogService.prototype.goToPreviousCounty = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canGoToPreviousSegment) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.goToSegmentAndSetOffset(this.videoLog.previousCountyCode, this.videoLog.stateRouteNumber, this.videoLog.previousSegmentNumber, 'last')];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        this.LoggingService.Log(error_3, LogLevel.Error);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VideoLogService.prototype.goToNextCounty = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canGoToNextSegment) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.goToSegmentAndSetOffset(this.videoLog.nextCountyCode, this.videoLog.stateRouteNumber, this.videoLog.nextSegmentNumber, 'first')];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        this.LoggingService.Log(error_4, LogLevel.Error);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VideoLogService.prototype.reverseDirection = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var oppositeOffset, error_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.gisToolsApi.getOppositeOffset(this.videoLog.countyCode, this.videoLog.stateRouteNumber, this.videoLog.juris, this.videoLog.segmentNumber, this.image.offset)];
                    case 1:
                        oppositeOffset = _a.sent();
                        if (!oppositeOffset) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.goToSegmentAndSetOffset(oppositeOffset.countyCode, oppositeOffset.stateRouteNumber, oppositeOffset.segmentNumber, oppositeOffset.offset)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_5 = _a.sent();
                        this.LoggingService.Log(error_5, LogLevel.Error);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    VideoLogService.prototype.startOrStopVideo = function () {
        if (this.playerState === 'play') {
            this.changePlayerState('stop');
        }
        else {
            this.changePlayerState('play');
        }
    };
    VideoLogService.prototype.resumeVideo = function () {
        if (this.playerState === 'pause') {
            this.changePlayerState('play');
        }
    };
    VideoLogService.prototype.stopVideo = function () {
        this.changePlayerState('stop');
    };
    VideoLogService.prototype.toggleFullsizeImages = function (fullsize) {
        var _this = this;
        if (fullsize === undefined || fullsize === null) {
            this.imageServerFolder = this.imageServerFolder === '/fullsize' ? '/thumbnails' : '/fullsize';
        }
        else {
            this.imageServerFolder = fullsize ? '/fullsize' : '/thumbnails';
        }
        if (this.images) {
            this.images.forEach(function (image) {
                image.url = undefined;
                _this.generateImageUrl(image);
            });
        }
    };
    Object.defineProperty(VideoLogService.prototype, "isFullSize", {
        get: function () { return this.imageServerFolder === '/fullsize'; },
        enumerable: true,
        configurable: true
    });
    VideoLogService.prototype.crsHasYear = function (crs, year) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsApi.getVideoLogForSegment(crs.countyCode, crs.stateRouteNumber, crs.segmentNumber, year)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.length > 0];
                }
            });
        });
    };
    VideoLogService.prototype.downloadImages = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var imageCount, imageList, data, url, leftUrl, rightUrl, strSubFolder, cn, bp, imageData, filename, error_6;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageCount = 15;
                        imageList = this.images.slice(this.image.sequenceNumber, this.image.sequenceNumber + imageCount);
                        imageList.forEach(function (image) {
                            _this.generateImageUrl(image);
                        });
                        data = imageList.map(function (image) {
                            if (image.imageName2 === '' || image.imageName3 === '') {
                                return [
                                    _this.videoLog.countyCode,
                                    _this.videoLog.stateRouteNumber,
                                    _this.videoLog.segmentNumber,
                                    image.offset,
                                    image.imageName1,
                                    image.url
                                ];
                            }
                            else {
                                return [
                                    _this.videoLog.countyCode,
                                    _this.videoLog.stateRouteNumber,
                                    _this.videoLog.segmentNumber,
                                    image.offset,
                                    image.imageName3,
                                    image.imageName1,
                                    image.imageName2,
                                    image.lurl,
                                    image.url,
                                    image.rurl
                                ];
                            }
                        });
                        url = '';
                        leftUrl = '';
                        rightUrl = '';
                        url += "/" + this.videoLog.year;
                        url += "/PA" + this.videoLog.year + "CO" + this.videoLog.countyCode;
                        strSubFolder = this.getSubFolder(this.image);
                        if (typeof (strSubFolder) === 'string') {
                            strSubFolder = strSubFolder.split(',');
                        }
                        if (this.videoLog.subFolders.find(function (sf) { return sf.toLowerCase() === 'row'; }) &&
                            this.videoLog.subFolders.find(function (sf) { return sf.toLowerCase() === 'forwardleft'; }) &&
                            this.videoLog.subFolders.find(function (sf) { return sf.toLowerCase() === 'forwardright'; })) {
                            leftUrl = url + "/" + this.videoLog.rootFolder + "/ForwardLeft/";
                            rightUrl = url + "/" + this.videoLog.rootFolder + "/ForwardRight/";
                            url += "/" + this.videoLog.rootFolder + "/ROW/";
                        }
                        else if (strSubFolder === undefined || strSubFolder[1] === '') {
                            leftUrl = url + "/" + this.videoLog.rootFolder + "/";
                            rightUrl = url + "/" + this.videoLog.rootFolder + "/";
                            url += "/" + this.videoLog.rootFolder + "/";
                        }
                        else if (this.currentYear > OLDYEAR) {
                            url += "/" + strSubFolder[0] + "/";
                            leftUrl += "/" + strSubFolder[0] + "/";
                            rightUrl += "/" + strSubFolder[0] + "/";
                        }
                        else {
                            leftUrl = url + "/" + OPTIONS.roadware1 + strSubFolder[0] + OPTIONS.routeLeftImageIdentifier;
                            rightUrl = url + "/" + OPTIONS.roadware1 + strSubFolder[0] + OPTIONS.routeRightImageIdentifier;
                            url += "/" + OPTIONS.roadware1 + strSubFolder[0] + OPTIONS.routeCenterImageIdentifier;
                            url += "/" + strSubFolder[1] + "/";
                            leftUrl += "/" + strSubFolder[1] + "/";
                            rightUrl += "/" + strSubFolder[1] + "/";
                        }
                        cn = [];
                        if (url !== leftUrl) {
                            cn = ['county', 'route', 'segment', 'offset', 'left image name', 'center image name', 'right image name', 'left url ', 'center url', 'right url'];
                            bp = { url: url, leftUrl: leftUrl, rightUrl: rightUrl };
                        }
                        else {
                            cn = ['county', 'route', 'segment', 'offset', 'left image name', 'center image name', 'right image name', 'url'];
                            bp = { url: url };
                        }
                        imageData = {
                            title: '15_Offset_Images',
                            columnNames: cn,
                            data: data,
                            basePaths: bp
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.http2.post('videolog/images', imageData, { responseType: 'text' })];
                    case 2:
                        filename = _a.sent();
                        if (filename) {
                            window.open([this.api.http2.url, 'videolog/file/', filename].join(''), '_blank');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        this.LoggingService.Log(error_6, LogLevel.Error);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VideoLogService.prototype.swapPanelUpdate = function (showThreeImages) {
        this.panelsSwapped.next(showThreeImages);
    };
    VideoLogService.prototype.toggleImage = function (imageName) {
        this.imagedToggled.next(imageName);
    };
    VideoLogService.prototype.resetImageToggleButtons = function () {
        this.imageToggleButtonsReset.next();
    };
    VideoLogService.prototype.changeCurrentOffset = function (imageIndex, fromClick) {
        if (fromClick === void 0) { fromClick = false; }
        if (imageIndex > -1 && this.images && imageIndex < this.images.length) {
            this.fromClick = fromClick;
            var image = this.images[imageIndex];
            this.generateVideoLogUrl(this.videoLog.countyCode, this.videoLog.stateRouteNumber, this.videoLog.segmentNumber, image.offset);
            this.generateImageUrl(image);
            if (window.location.href.includes('isPopUp=true') && window.location.href.includes('pos=') && image.url) {
                /* In a pop out window, continues to use the left or right image when user advances */
                var nextChar = window.location.href.charAt(window.location.href.indexOf('pos=') + 'pos='.length);
                if (nextChar === 'l') {
                    image.url = image.lurl;
                }
                else if (nextChar === 'r') {
                    image.url = image.rurl;
                }
            }
            this.setNewOffsetImage(image);
        }
    };
    VideoLogService.prototype.setNewOffsetImage = function (image) {
        this.image = image;
        this.newOffset.next(image);
    };
    VideoLogService.prototype.changePlayerState = function (suggestedState) {
        switch (suggestedState) {
            case 'play':
                if (this.playerState === 'stop' || this.playerState === 'pause') {
                    this.playerState = suggestedState;
                    this.newPlayerState.next(this.playerState);
                    this.playerTimerSub = timer(0, this.playerSpeed * SECOND).subscribe(this.goToNextOffset.bind(this));
                }
                break;
            case 'stop':
                if (this.playerState === 'play') {
                    this.playerState = suggestedState;
                    this.newPlayerState.next(this.playerState);
                    this.playerTimerSub.unsubscribe();
                }
                else if (this.playerState === 'pause') {
                    this.playerState = suggestedState;
                    this.newPlayerState.next(this.playerState);
                }
                break;
            case 'pause':
                if (this.playerState === 'play') {
                    this.playerState = suggestedState;
                    this.newPlayerState.next(this.playerState);
                    this.playerTimerSub.unsubscribe();
                }
                break;
            default:
                break;
        }
    };
    VideoLogService.prototype.generateVideoLogUrl = function (county, route, segment, offset) {
        var videoLogUrl = OPTIONS.baseUrl;
        if (county && route && segment) {
            videoLogUrl += "?cn=" + county + "&rt=" + route + "&sg=" + segment;
            if (offset) {
                videoLogUrl += "&offset=" + offset;
            }
        }
        this.videoLogUrl = videoLogUrl;
    };
    VideoLogService.prototype.generateImageUrl = function (image) {
        var imageLeftUrl = '';
        var imageRightUrl = '';
        if (!image.url) {
            if (this.videoLog && this.videoLog.stateRouteNumber && this.videoLog.rootFolder) {
                var imageUrl = OPTIONS.imagesLocation + this.imageServerFolder;
                if (this.isRamp(this.videoLog.stateRouteNumber)) {
                    imageUrl += "/" + OPTIONS.rampsFolder;
                    imageUrl += this.videoLog.rootFolder;
                    imageLeftUrl = imageUrl + OPTIONS.rampLeftImageIdentifier;
                    imageRightUrl = imageUrl + OPTIONS.rampRightImageIdentifier;
                    imageUrl += OPTIONS.rampCenterImageIdentifier;
                }
                else {
                    imageUrl += "/" + this.videoLog.year;
                    imageUrl += "/PA" + this.videoLog.year + "CO" + this.videoLog.countyCode;
                    var strSubFolder = this.getSubFolder(image);
                    if (typeof (strSubFolder) === 'string') {
                        strSubFolder = strSubFolder.split(',');
                    }
                    if (this.videoLog.subFolders.find(function (sf) { return sf.toLowerCase() === 'row'; }) &&
                        this.videoLog.subFolders.find(function (sf) { return sf.toLowerCase() === 'forwardleft'; }) &&
                        this.videoLog.subFolders.find(function (sf) { return sf.toLowerCase() === 'forwardright'; })) {
                        imageLeftUrl = imageUrl + "/" + this.videoLog.rootFolder + "/ForwardLeft/";
                        imageRightUrl = imageUrl + "/" + this.videoLog.rootFolder + "/ForwardRight/";
                        imageUrl += "/" + this.videoLog.rootFolder + "/ROW/";
                        //open 3 image view if it is not already
                        if (this.fromClick) {
                            this.openThreeImageView.next(true);
                        }
                    }
                    else if (strSubFolder === undefined || strSubFolder[1] === '') {
                        imageLeftUrl = imageUrl + "/" + this.videoLog.rootFolder + "/";
                        imageRightUrl = imageUrl + "/" + this.videoLog.rootFolder + "/";
                        imageUrl += "/" + this.videoLog.rootFolder + "/";
                        if (this.fromClick) {
                            this.openThreeImageView.next(false);
                        }
                    }
                    else if (this.currentYear > OLDYEAR) {
                        imageUrl += "/" + strSubFolder[0] + "/";
                        imageLeftUrl += "/" + strSubFolder[0] + "/";
                        imageRightUrl += "/" + strSubFolder[0] + "/";
                        if (this.fromClick) {
                            this.openThreeImageView.next(false);
                        }
                    }
                    else {
                        imageLeftUrl = imageUrl + "/" + OPTIONS.roadware1 + strSubFolder[0] + OPTIONS.routeLeftImageIdentifier;
                        imageRightUrl = imageUrl + "/" + OPTIONS.roadware1 + strSubFolder[0] + OPTIONS.routeRightImageIdentifier;
                        imageUrl += "/" + OPTIONS.roadware1 + strSubFolder[0] + OPTIONS.routeCenterImageIdentifier;
                        imageUrl += "/" + strSubFolder[1] + "/";
                        imageLeftUrl += "/" + strSubFolder[1] + "/";
                        imageRightUrl += "/" + strSubFolder[1] + "/";
                    }
                }
                imageUrl += "" + image.imageName1 + OPTIONS.imageExtension;
                imageLeftUrl += "" + image.imageName3 + OPTIONS.imageExtension;
                imageRightUrl += "" + image.imageName2 + OPTIONS.imageExtension;
                image.url = imageUrl;
                image.lurl = imageLeftUrl;
                image.rurl = imageRightUrl;
                if (this.videoLog.isHighDef) {
                    image.lurl = imageUrl;
                    image.rurl = imageUrl;
                }
                image.isHighDef = this.videoLog.isHighDef;
            }
        }
    };
    VideoLogService.prototype.isRamp = function (route) {
        return route >= '8000' && route <= '8999';
    };
    VideoLogService.prototype.getSubFolder = function (image) {
        var _this = this;
        var e_1, _a;
        var subFolder = image.imageName1;
        var imageNumber = parseInt(subFolder, 10);
        var lstSubFolders = [];
        if (!isNaN(imageNumber)) {
            if (this.videoLog.subFolders !== undefined && this.videoLog.subFolders instanceof Array) {
                if (this.videoLog.subFolders.find(function (sf) { return sf.toLowerCase() === 'row'; }) &&
                    this.videoLog.subFolders.find(function (sf) { return sf.toLowerCase() === 'forwardleft'; }) &&
                    this.videoLog.subFolders.find(function (sf) { return sf.toLowerCase() === 'forwardright'; })) {
                    return this.videoLog.subFolders;
                }
                else if (this.videoLog.subFolders[0] === '') {
                    subFolder = '';
                }
                else {
                    var additionalFolder = this.videoLog.additionalFolders.find(function (x) { return x.rootFolder === _this.videoLog.rootFolder; });
                    if (additionalFolder) {
                        lstSubFolders = additionalFolder.subFolders;
                    }
                    try {
                        for (var lstSubFolders_1 = tslib_1.__values(lstSubFolders), lstSubFolders_1_1 = lstSubFolders_1.next(); !lstSubFolders_1_1.done; lstSubFolders_1_1 = lstSubFolders_1.next()) {
                            var lstSubFolder = lstSubFolders_1_1.value;
                            var folderNumber = parseInt(lstSubFolder, 10);
                            if (!isNaN(folderNumber)) {
                                if (folderNumber > imageNumber) {
                                    break;
                                }
                                subFolder = lstSubFolder;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (lstSubFolders_1_1 && !lstSubFolders_1_1.done && (_a = lstSubFolders_1.return)) _a.call(lstSubFolders_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            }
        }
        return this.videoLog.rootFolder + "," + subFolder;
    };
    VideoLogService.prototype.highlightSegment = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var searchCriteria, forcedStop;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        searchCriteria = {
                            type: 'route',
                            title: "Route (" + this.videoLog.stateRouteNumber + ")",
                            stateRouteNumber: this.videoLog.stateRouteNumber
                        };
                        if (this.videoLog.countyCode) {
                            searchCriteria.title += "County (" + this.videoLog.countyCode + ")";
                            searchCriteria.countyCode = this.videoLog.countyCode;
                        }
                        if (this.videoLog.segmentNumber) {
                            searchCriteria.title = searchCriteria.title + " " + this.videoLog.segmentNumber + "-" + this.videoLog.nextSegmentNumber;
                            searchCriteria.segBgn = this.videoLog.segmentNumber;
                            searchCriteria.segEnd = this.videoLog.segmentNumber;
                        }
                        this.aoiService.setSearchCriterias([searchCriteria]);
                        forcedStop = false;
                        if (this.playerState === 'play') {
                            this.startOrStopVideo();
                            forcedStop = true;
                        }
                        return [4 /*yield*/, this.aoiService.showBySearchCriterias(true, false, false)];
                    case 1:
                        _a.sent();
                        if (forcedStop && this.playerState === 'stop') {
                            this.startOrStopVideo();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    VideoLogService.ngInjectableDef = i0.defineInjectable({ factory: function VideoLogService_Factory() { return new VideoLogService(i0.inject(i1.Api), i0.inject(i2.GisToolsApi), i0.inject(i3.AoiService), i0.inject("LoggingService")); }, token: VideoLogService, providedIn: "root" });
    return VideoLogService;
}());
export { VideoLogService };
